import React from 'react';
import classNames from 'classnames';
import { Thumbnail } from '../../../../general/components/Thumbnail/Thumbnail';
import { FileOutlinedWithExtension } from '../../../../general/components/FullscreenPreview/viewers/MediaUnknown';

// Square thumbnail that shows the whole image (object-fit: contain) with a
// filename-based fallback, reusing the finder's Thumbnail loader. Accepts a
// plain src so it works for Asset Lab assets and locally uploaded images.
// Pass a fixed `size`, or `fill` to make it a square that fills its column.
export const AssetThumb: React.FC<{
  src: string | null;
  name: string;
  size?: number;
  fill?: boolean;
  className?: string;
}> = ({ src, name, size, fill, className }) => {
  const fallback = <FileOutlinedWithExtension filename={name} />;
  const style: React.CSSProperties = fill
    ? { width: '100%', aspectRatio: '1 / 1' }
    : { width: size, height: size };

  return (
    <div className={classNames('al-magic-thumb', className)} style={style}>
      {src ? (
        <Thumbnail
          className="al-magic-thumb__img"
          alt={name}
          src={src}
          fallback={fallback}
          retry={false}
        />
      ) : (
        fallback
      )}
    </div>
  );
};
